import { Link } from "gatsby";
import React, { useEffect, useRef, useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { HomeUpdatedArrowSmall } from "../../../app-constants";
import { StaticImage } from "gatsby-plugin-image";

import modelOneMp4 from "../../images/home-update/models/models-1.mp4";
import modelOneImage from "../../images/home-update/models/model_1.webp";

import modelTwoMp4 from "../../images/home-update/models/models-2.mp4";
import modelTwoImage from "../../images/home-update/models/model_2.webp";

import modelThreeMp4 from "../../images/home-update/models/models-3.mp4";
import modelThreeImage from "../../images/home-update/models/model_3.webp";

export default function Models({ handleShow }) {
  const [videoLoaded, setVideoLoaded] = useState(false);
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting) {
          setVideoLoaded(true);
          observer.disconnect(); // Stop observing once the video is loaded
        }
      },
      { threshold: 0.1 } // Adjust the threshold as needed
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      if (observer && sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);
  return (
    <>
      <section
        className="tekrevol__model p-100 overflow-x-hidden"
        ref={sectionRef}
      >
        <Container>
          <Row>
            <Col xs={12} md={12} lg={7} xl={7} xxl={7} className="">
              <div className="example example-bottom" data-text="Our Models">
                <h2>Our Engagement Models</h2>
              </div>
            </Col>
          </Row>

          <Row className="justify-content-center">
            <Col
              xs={12}
              sm={6}
              md={6}
              lg={4}
              xl={4}
              xxl={4}
              className="mb-lg-0 mb-4"
            >
              <div className="serv-item">
                <div className="serv-inner tekrevol_gray_bg">
                  <div className="image-wrap">
                    {videoLoaded ? (
                      <video
                        poster={modelThreeImage}
                        autoPlay
                        loop
                        muted
                        playsInline
                        className="w-auto mw-100"
                      >
                        <source src={modelThreeMp4} type="video/mp4" />
                      </video>
                    ) : (
                      <StaticImage
                        src="../../images/home-update/models/model_3.webp"
                        alt="Models"
                        className="img-fluid mw-100"
                        layout="constrained"
                        placeholder="blurred"
                        formats={["auto"]}
                        width={390}
                        height={350}
                      />
                    )}
                  </div>
                  <div className="content-wrap">
                    <h3 className="title">Project-Based Development</h3>
                    <p>
                      Assign dedicated PMs &amp; developers for your software
                      development project.
                    </p>
                  </div>
                </div>
              </div>
            </Col>
            <Col xs={12} sm={6} md={6} lg={4} xl={4} xxl={4} className="">
              <div className="serv-item">
                <div className="serv-inner tekrevol_gray_bg">
                  <div className="image-wrap">
                    {videoLoaded ? (
                      <video
                        poster={modelTwoImage}
                        autoPlay
                        loop
                        muted
                        playsInline
                        className="w-auto mw-100"
                      >
                        <source src={modelTwoMp4} type="video/mp4" />
                      </video>
                    ) : (
                      <StaticImage
                        src="../../images/home-update/models/model_2.webp"
                        alt="Models"
                        className="img-fluid mw-100"
                        layout="constrained"
                        placeholder="blurred"
                        formats={["auto"]}
                        width={390}
                        height={349}
                      />
                    )}
                  </div>
                  <div className="content-wrap">
                    <h3 className="title">Team-Based Development</h3>
                    <p>
                      Deploy a cohesive team to deliver end-to-end, custom
                      software solutions.
                    </p>
                  </div>
                </div>
              </div>
            </Col>
            <Col
              xs={12}
              sm={6}
              md={6}
              lg={4}
              xl={4}
              xxl={4}
              className="mb-lg-0 mb-4"
            >
              <div className="serv-item">
                <div className="serv-inner tekrevol_gray_bg">
                  <div className="image-wrap">
                    {videoLoaded ? (
                      <video
                        poster={modelOneImage}
                        autoPlay
                        loop
                        muted
                        playsInline
                        className="w-auto mw-100"
                      >
                        <source src={modelOneMp4} type="video/mp4" />
                      </video>
                    ) : (
                      <StaticImage
                        src="../../images/home-update/models/model_1.webp"
                        alt="Models"
                        className="img-fluid mw-100"
                        layout="constrained"
                        placeholder="blurred"
                        formats={["auto"]}
                        width={390}
                        height={350}
                      />
                    )}
                  </div>
                  <div className="content-wrap">
                    <h3 className="title">Staff Augmentation</h3>
                    <p>
                      Integrate top-tier app developers into your team for
                      enhanced project success.
                    </p>
                  </div>
                </div>
              </div>
            </Col>
            <Col
              xs={12}
              md={12}
              lg={12}
              xl={12}
              xxl={12}
              className="mt-auto mb-auto"
            >
              <div className="btn-wrap text-center">
                <span className="btn-pri" onClick={handleShow}>
                  Book a Free Consultation
                </span>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
}
